import { Box, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from 'react-router-dom';
import PaymentIcon from '@mui/icons-material/Payment';

const useStyles = makeStyles(theme => ({
    containerPlanInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    planInfo: {
        display: "flex",
        alignItems: "center",
        minHeight: 38,
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(244, 250, 254, 0.99) 58%, rgba(235, 245, 250, 0.98) 100%)',
        color: theme.palette.primary.main,
        padding: theme.spacing(0.55, 1.1),
        borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
        border: '1px solid rgba(37, 134, 188, 0.16)',
        overflow: "hidden",
        width: "fit-content",
        transform: 'none',
        boxShadow: '0 10px 18px rgba(8, 41, 63, 0.08), 0 1px 0 rgba(255,255,255,0.95)',
        transition: "box-shadow 180ms ease, background 180ms ease, border-color 180ms ease",
        cursor: "pointer",
        "&:hover": {
            transform: 'none',
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(247, 252, 255, 1) 58%, rgba(238, 247, 252, 1) 100%)',
            boxShadow: '0 14px 22px rgba(8, 41, 63, 0.12), 0 1px 0 rgba(255,255,255,1)',
            borderColor: 'rgba(37, 134, 188, 0.2)',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '1.2rem',
        }
    },
    planText: {
        marginLeft: theme.spacing(0.85),
        whiteSpace: "nowrap",
        transition: "opacity 0.4s ease, max-width 0.4s ease, margin 0.3s ease",
        opacity: 0,
        maxWidth: 0,
        overflow: "hidden",
        display: "inline-block",
        fontWeight: 500,
        letterSpacing: -0.1,
        "&.visible": {
            opacity: 1,
            maxWidth: 220,
            marginRight: theme.spacing(0.35),
        },
        "&.hidden": {
            opacity: 0,
            maxWidth: 0,
            margin:0
        },
    },
}));

export default function IndicatorPlan({ plan }) {
    const classes = useStyles();
    const [hovered, setHovered] = useState(false);
    let history = useHistory();
    const goToPayments = () => {
        history.push('/pagos');
    }

    return (     
        <Box
            className={classes.planInfo}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={goToPayments}
        >
            <PaymentIcon />
            <Typography
                variant="body2"
                className={`${classes.planText} ${hovered ? "visible" : "hidden"}`}
            >
                {plan?.info?.plan || 'Plan no definido'}
            </Typography>
        </Box>
    )
}
